import { devApiUrl } from "../../config";
const querystring = require("querystring");
export const fetchData = (onProgress, endpoint, queryParamsObj) => {
  return new Promise((resolve, reject) => {
    try {
      const baseUrl = `${devApiUrl}${endpoint}`;

      // Construct the URL with query parameters
      // const queryParams = new URLSearchParams(queryParamsObj).toString();

      // Convert the JSON object to a string and then encode it

      const encodedData = querystring.stringify(queryParamsObj);

      const fullUrl = `${baseUrl}/${encodeURIComponent(encodedData)}`;
      const eventSource = new EventSource(fullUrl);

      eventSource.onmessage = function (event) {
        const data = JSON.parse(event.data).state_object;

        if (data.status === "in progress") {
          onProgress(data);
        } else if (data.error === true) {
          onProgress(data);
          console.error("An error occurred:", data);
          eventSource.close(); // Close the connection after receiving an error
          reject(new Error(data.message || "An error occurred")); // Reject the promise with the error
        } else if (data.status === "completed") {
          onProgress(data);
          eventSource.close(); // Close the connection after receiving the final data
          resolve(); // Resolve the promise indicating the process is complete
        }
      };

      eventSource.onerror = function (err) {
        console.error("EventSource failed:", err);
        eventSource.close();
        reject(err); // Reject the promise if there's an EventSource error
      };

      return () => {
        eventSource.close();
      };
    } catch (error) {
      console.error("Error fetching progress:", error);
      reject(error); // Reject the promise if there's an error in setting up EventSource
    }
  });
};
